import PropTypes from 'prop-types';
import {Component} from 'react';
import {connect} from 'react-redux';
import {postcodeAnywhereShowFields} from '../../actions/address-actions';
import Input from '../../form/InputField';
import AddressFieldList from './AddressFields';
import legacyNameUtil from './legacy-name-util';
import postCodeAnywhereApi from './postcode-anywhere-api';
import PostcodeAnywhereInput, {VALIDATE_THAT_OTHER_FIELDS_ARE_SHOWN} from './PostcodeAnywhereInput';

export class PostcodeAnywhere extends Component {
  constructor(props) {
    super(props);
    this.resetAddress = this.resetAddress.bind(this);
    this.setShowOtherFields = this.setShowOtherFields.bind(this);
    this.postcodeAnywhere = postCodeAnywhereApi.get(this.props.addressType);
    this.postcodeAnywhere.setCallbackToSetAddress(this.resetAddress);
  }
  
  setShowOtherFields() {
    this.props.showFields(this.props.addressType, true);
  }
  
  shouldUpdateDeliveryOptions = () => this.props.fieldNamePrefix !== 'editAddressForm.'
    && typeof this.props.updateDeliveryOptions === 'function'
    && this.props.updateDeliveryOptions();
  
  isShowOtherFields() {
    return !this.props.isEnabled || this.props.postcodeAnywhere[this.props.addressType].isShowFields;
  }
  
  resetAddress(newValues) {
    this.setShowOtherFields();
    this.props.resetAddress(newValues);
    this.props.fieldContainer.validate(this.props.fieldNamePrefix + this.props.definedField.name);
    this.props.fieldContainer.validate(VALIDATE_THAT_OTHER_FIELDS_ARE_SHOWN);
    this.shouldUpdateDeliveryOptions();
  }
  
  postcodeField() {
    const {definedField} = this.props;
    const legacyNames = legacyNameUtil.get(this.props.addressType, this.props.fieldNamePrefix, definedField.name);
    
    if (this.props.isEnabled) {
      return (
        <PostcodeAnywhereInput
          disabled={this.props.disabled}
          key="a"
          fieldContainer={this.props.fieldContainer}
          addressType={this.props.addressType}
          value={this.props.fieldValues[definedField.name]}
          fieldNamePrefix={this.props.fieldNamePrefix}
          definedField={definedField}
          isShowOtherFields={this.isShowOtherFields()}
          clickEnterManuallyLink={this.setShowOtherFields}
          postcodeAnywhere={this.postcodeAnywhere}
          legacyNames={legacyNames}
          updateDeliveryOptions={this.props.updateDeliveryOptions}
        />
      );
    }
    return (
      <Input
        key="a"
        disabled={this.props.disabled}
        fieldContainer={this.props.fieldContainer}
        addressType={this.props.addressType}
        value={this.props.fieldValues[definedField.name]}
        fieldNamePrefix={this.props.fieldNamePrefix}
        definedField={definedField}
        legacyNames={legacyNames}
        onBlur={this.props.updateDeliveryOptions}
      />
    );
  }
  
  render() {
    return (
      <>
        {this.postcodeField()}
        {this.isShowOtherFields() && (
          <AddressFieldList
            disabled={this.props.disabled}
            key="b"
            definedFields={this.props.definedField.fields}
            addressType={this.props.addressType}
            fieldContainer={this.props.fieldContainer}
            fieldNamePrefix={this.props.fieldNamePrefix}
            fieldValues={this.props.fieldValues}
          />
        )}
      </>
    );
  }
}

PostcodeAnywhere.propTypes = {
  addressType: PropTypes.oneOf(['delivery', 'billing']).isRequired,
  definedField: PropTypes.object.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  fieldNamePrefix: PropTypes.string.isRequired,
  fieldContainer: PropTypes.object.isRequired,
  fieldValues: PropTypes.object.isRequired,
  showFields: PropTypes.func.isRequired,
  postcodeAnywhere: PropTypes.object.isRequired,
  resetAddress: PropTypes.func.isRequired,
  updateDeliveryOptions: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const mapStateToProps = state => ({
  isEnabled: state.site.isPostcodeLookupEnabled,
  postcodeAnywhere: state.address.postcodeAnywhere,
});

const mapDispatchToProps = dispatch => ({
  showFields: (addressType, isShowFields) => dispatch(postcodeAnywhereShowFields(addressType, isShowFields)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostcodeAnywhere);
